const navItems = [{name: 'Fantasy', link: '/'}, {name: 'Sportsbook', link: '/'}, {name: 'Prizepicks', link: '/prizepicks'}];

let API_KEY;

if (process.env.REACT_APP_ENVIRONMENT === 'development') {
  API_KEY = 'http://localhost:5050/api/v1';
} else {
  API_KEY = 'https://newdfswebsite.onrender.com/api/v1';
}

export {navItems, API_KEY};